import { alpha } from "@mui/material";
import theme, { responsiveFontSize } from "./Theme";

export const globalStyle = {
  sectionHeading: {
    color: theme.palette.primary.main,
    fontSize: responsiveFontSize(48),
    fontWeight: 400,
    "& span": {
      backgroundColor: alpha(theme.palette.primary.light, 0.2),
      color: theme.palette.text.primary,
      padding: "0 20px",
      borderRadius: "3em",
    },
  },
  sectionSubheading: {
    color: theme.palette.text.secondary,
    fontSize: "clamp(1rem, 3vw, 1.25rem)",
    fontWeight: 400,
    marginTop: "0.5em",
  },
};
